import React, { useMemo, useState } from "react";
import Grid from "@mui/material/Grid";
import { Container, TextField, Button } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { NavLink } from "react-router-dom";
import Header from "../../components/Header/Header";
import IconButton from "@mui/material/IconButton";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik, Form, Field } from "formik";

const MaterialHistory = () => {
  const [rowData] = useState([
    {
      slno: "1",
      date: "11-04-2023",
      qty: "10",
      uom: "cm",
      type: "",
      purchase: "",
      stockout: "",
    },
  ]);

  const [columnDefs] = useState([
    {
      field: "slno",
      headerName: "S.No.",
      sortable: true,
      filter: false,
      maxWidth: 80,
    },
    {
      field: "date",
      headerName: "Date",
      sortable: true,
      filter: "agDateColumnFilter",
    },

    {
      field: "qty",
      headerName: "Quantity",
      sortable: true,
    },
    {
      field: "uom",
      headerName: "UOM",
      sortable: true,
    },
    {
      field: "type",
      headerName: "Type",
      sortable: true,
    },
    {
      field: "purchase",
      headerName: "Purchase",
      sortable: true,
    },
    {
      field: "stockout",
      headerName: "Stock Out",
      sortable: true,
    },
  ]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      floatingFilter: true,
      autoHeight: true,
    };
  }, []);

  return (
    <>
      <Header />
      <Container maxWidth={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="grid-tabs-container">
              <Grid item xs={12}>
                <div className="nav-bar">
                  <NavLink
                    to="/report/production-report"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Production Report
                  </NavLink>
                  <NavLink
                    to="/report/material-history"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Material History
                  </NavLink>
                  <NavLink
                    to="/report/raw-material"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Raw Material Report
                  </NavLink>
                </div>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid container className="mt-25">
          <Grid item xs={3}>
            <h4 className="title mt-10">Material History</h4>
          </Grid>
          <Grid item xs={9} className="search-bar">
            <Formik
              initialValues={{
                uom: "",
              }}
              onSubmit={async (values) => {
                await new Promise((r) => setTimeout(r, 500));
                // alert(JSON.stringify(values, null, 2));
                console.log(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit} className="d-flex">
                  <div className="d-flex">
                    <label className="mt-10">From</label>
                    <Field
                      type="date"
                      name="from"
                      className="w-100 search-input"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="d-flex">
                    <label className="mt-10">To</label>
                    <Field
                      type="date"
                      name="to"
                      className="w-100 search-input"
                      onChange={handleChange}
                    />
                  </div>
                  <Field
                    as="select"
                    name="color"
                    className="w-100 search-input"
                    onChange={handleChange}
                  >
                    <option value="all">All</option>
                    <option value="order">Order</option>
                    <option value="display">Display</option>
                  </Field>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="search-button"
                  >
                    Search
                  </Button>
                </Form>
              )}
            </Formik>

            <div className="action-buttons">
              <IconButton disabled>
                <PrintIcon />
              </IconButton>
              <IconButton disabled>
                <EditIcon />
              </IconButton>
              <IconButton disabled>
                <DeleteIcon />
              </IconButton>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="ag-theme-alpine" style={{ height: 400 }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                rowDragManaged={true}
                defaultColDef={defaultColDef}
              ></AgGridReact>
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MaterialHistory;
